class EfWizard {
    constructor() {
        this.steps = []
    }

    addStep(step) {
        this.steps = [...this.steps, step].sortBy(s => s.order)

        if (!this.activeStepId && this.steps.length) {
            this.activeStepId = this.steps[0].id
        }
    }

    removeStep(step) {
        this.steps = this.steps.reject(s => step.id === s.id)
    }

    stepClick(step) {
        if (step.order < this.activeStep.order) {
            this.activeStepId = step.id
        }
    }

    get activeStep() {
        return this.steps.find(({ id }) => id == this.activeStepId)
    }

    get progress() {
        const width = this.width

        const activeOrder = this.activeStep ? this.activeStep.order : undefined

        const progress = this.steps.filter(({ order }) => order <= activeOrder).length

        return ((progress - 1) * width) + (width / 2)
    }

    get width() {
        return 100 / this.steps.length
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efWizard', {
        controller: [EfWizard],
        transclude: true,
        bindings: {
            activeStepId: '=?active'
        },
        template: `
            <div class="wizard">
                <div class="steps">
                    <div 
                        class="cursor-pointer"
                        style="width: {{$ctrl.width}}%"
                        ng-click="$ctrl.stepClick(step)"
                        ng-repeat="step in $ctrl.steps" 
                        ng-class="{'step': true, 'passed': step.order < $ctrl.activeStep.order, 'active': $ctrl.activeStep.id == step.id}">
                        <div class="icon">
                            <i class="fa {{step.icon}}"></i>
                        </div>
                    </div>
                </div>
                <div class="progress-line">
                    <div class="progress" style="width: {{$ctrl.progress}}%"></div>
                </div>
                <div class="labels">
                    <div 
                        style="width: {{$ctrl.width}}%"
                        ng-repeat="step in $ctrl.steps" 
                        ng-class="{'step-label': true, 'passed': step.order < $ctrl.activeStep.order, 'active': $ctrl.activeStep.id == step.id}">
                        <span>{{step.label}}</span>
                    </div>
                </div>
            </div>
            <div class="step-content" ng-transclude>
            </div>
        `
    })

class EfWizardStep {
    $onInit() {
        this.wizardCtrl.addStep(this)
    }

    $onDestroy() {
        this.wizardCtrl.removeStep(this)
    }

    get active() {
        return this.wizardCtrl.activeStepId == this.id
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efWizardStep', {
        controller: [EfWizardStep],
        transclude: true,
        require: {
            wizardCtrl: '^efWizard'
        },
        bindings: {
            id: '@',
            label: '@',
            icon: '@',
            order: '@'
        },
        template: `
            <div class="step-content" ng-show="$ctrl.active" ng-transclude></div>
        `
    })
